import axios from "axios";
import React, { useEffect, useState } from "react";

const MemberRegister = () => {
  const [registerUser, setRegisterUser] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");

  const register = () => {
    axios({
      method: "post",
      data: {
        username: registerUser,
        password: registerPassword,
      },
      withCredentials: true,
      url: "http://localhost:3000/MemberRegister",
    })
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  };

  return (
    <div className="w-full h-[2000px]">
      <h1 className=" text-4xl text-black font-bold pt-40 items-center justify-center flex">
        Register Here
      </h1>
      {console.log(registerUser)}
      <div className=" py-10 justify-center items-center grid ">
        <div>
          <label htmlFor="">
            {" "}
            UserName
            <input
              type="text"
              name="username"
              placeholder="  username"
              onChange={(e) => setRegisterUser(e.target.value)}
            />
          </label>
        </div>

        <div>
          <label htmlFor="">
            Password
            <input
              type="password"
              name="password"
              placeholder="    password"
              onChange={(e) => setRegisterPassword(e.target.value)}
            />
          </label>
        </div>
      </div>
      <button
        onClick={register}
        className=" py-5 px-5 text-white border-2  hover:bg-blue-700 hover:border-blue-600   mx-auto flex items-center opacity-75 hover:opacity-100"
        type="submit"
      >
        Register
      </button>
    </div>
  );
};

export default MemberRegister;
